module.exports = __webpack_public_path__ + "img/791.04608c7b.png";